export const allStorage = () => {
  const values = [];
  const keys = Object.keys(localStorage);
  let i = keys.length;

  while (i--) {
    values.push(localStorage.getItem(keys[i]));
  }

  return values;
};

export const getAuthToken = () => {
  if (sessionStorage.getItem("accessToken")) {
    return sessionStorage.getItem("accessToken");
  }
  return localStorage.getItem("accessToken");
};

export const graphqlErrorParse = ({ err }) => {
  const errString = JSON.stringify(err);
  return JSON.parse(errString);
};

export const preparePayloadWithoutId = (id, payload) => {
  const payloadNew = { ...payload };
  delete payloadNew[id];
  return payloadNew;
};

export function OneDotSvg(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="currentColor" className="bi bi-dot" viewBox="0 0 16 16" {...props}>
      <path d="M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" />
    </svg>
  );
}
export function extractDomainAndProtocol(website) {
  try {
    const url = new URL(website);
    const domain = url.hostname;
    // const protocol = url.protocol.replace(/:$/, ""); // Remove the trailing colon
    const protocol = url.protocol;
    return { domain, protocol };
  } catch (e) {
    // Handle errors if the URL is invalid
    console.error("Something went wrong:", e);
    return null; // You can return an error message or handle it differently
  }
}

export function formatDate(dateString) {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.toLocaleString("default", { month: "short" });
  const year = date.getFullYear();
  const monthNumber = date.getMonth();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";
  const formattedHours = hours % 12 === 0 ? 12 : hours % 12;

  // const formattedDate = `${day} ${month} ${year} ${formattedHours}:${minutes.toString().padStart(2, "0")} ${ampm}`;
  const obj = { day, month, year, formattedHours, ampm, minute: minutes.toString().padStart(2, "0"), monthNumber };
  return obj;
}

export const dateless10 = num => {
  if (num < 10) return `0${num}`;
  return num;
};

export const titleUpdate = planType => {
  switch (planType) {
    case "FREEMIUM":
      return { heading: "Currently you have an free plan.", subHeading: "If you want to see more information then buy our premium plan." };
    case "STANDARD":
      return { heading: "Currently, you are on the Basic Plan.", subHeading: "Upgrade now to unlock more features with our Advanced Plan!" };
    case "PREMIUM":
      return { heading: "Enjoy powerful features of Advanced Plan.", subHeading: "boost your SEO game!" };
    case "ENTERPRISES":
      return { heading: "Enjoy powerful features of Advanced Plan", subHeading: "boost your SEO game!" };
    default:
      return { heading: "Currently, you are on the Basic Plan.", subHeading: "Upgrade now to unlock more features with our Advanced Plan!" };
  }
};

export const errorArray = [
  // 'internal3xx&internalPage',
  "internal4xx&internalPage",
  "internal5xx&internalPage",

  "status4xx&Indexability",
  "status5xx&Indexability",
  "pointToRedirect&Indexability",

  "noOutgoingLink&Links&indexable",
  "orphanePage&Links&indexable",
  "linkToBrokenPage&Links&indexable",
  "canonicalNotIncoming&Links&indexable",
  "httpsTohttpInternal&Links&indexable",
  "noOutgoingInternalLinks&Links&indexable",

  "brokenRedirect&redirectFlag",
  "redirectChainTooLong&redirectFlag",
  "redirectLoop&redirectFlag",

  "multipleMetaDesc&content&indexable",
  "multipleTitleTag&content&indexable",
  "titleTagMissing&content&indexable",

  "duplicate",

  "imageBroken&imagesFlag",
  "pageHasBrokenImage&imagesFlag",

  "jsBroken&jsFlags",
  "pageHasBrokenJs&jsFlags",
];

export const infoArray = [
  "status2xx&Indexability",
  "status200&Indexability",
  "noFollowIndex&Indexability",
  "httpToHttps&Indexability",
  "httpsToHttp&Indexability",

  "onlyOneDofollow&Links&indexable",
  "httpTohttpsInternal&Links&indexable",
  "dofollowAndNofollow&Links&indexable",
  "noFollowOutgoingInternalLinks&Links&indexable",

  "linkToRedirect&Links&notIndexable",
  "nofollowIncomingOnly&Links&notIndexable",
  "redirectPageHasNoIncoming&Links&notIndexable",
  "onlyOneDofollow&Links&notIndexable",
  "httpTohttpsInternal&Links&notIndexable",
  "dofollowAndNofollow&Links&notIndexable",
  "noFollowOutgoingInternalLinks&Links&notIndexable",

  "httpToHttpsRedirect&redirectFlag",
  "redirectChain&redirectFlag",

  "multipleH1Tags&content&indexable",

  "multipleH1Tags&content&nonIndexable",
  "titleSort&content&nonIndexable",
  "h1TagMissing&content&nonIndexable",
  "metaDescLong&content&nonIndexable",
  "metaDescSort&content&nonIndexable",
  "titleLong&content&nonIndexable",
  "lowWordCount&content&nonIndexable",

  "openGraphTagsMissing&socialTag",
  "twitterCardMissing&socialTag",

  "external3xxRedirect&externalPagesFlag",
  "external4xx&externalPagesFlag",
  "external5xx&externalPagesFlag",
];

export const warningArray = [
  "mixedContent&internalPage",

  "status300&Indexability",
  "noFollow&Indexability",
  "noIndex&Indexability",
  "noFollowInHttpHeader&Indexability",
  "noIndexInHttpHeader&Indexability",

  "linkToRedirect&Links&indexable",
  "redirectPageHasNoIncoming&Links&indexable",
  "nofollowIncomingOnly&Links&indexable",

  "noOutgoingLink&Links&notIndexable",
  "orphanePage&Links&notIndexable",
  "linkToBrokenPage&Links&notIndexable",
  "httpsTohttpInternal&Links&notIndexable",
  "noOutgoingInternalLinks&Links&notIndexable",

  "redirect3xx&redirectFlag",
  "redirect302&redirectFlag",
  "httpsToHttpRedirect&redirectFlag",

  "metaDescMissing&content&indexable",
  "titleSort&content&indexable",
  "h1TagMissing&content&indexable",
  "metaDescLong&content&indexable",
  "metaDescSort&content&indexable",
  "titleLong&content&indexable",
  "lowWordCount&content&indexable",

  "multipleMetaDesc&content&nonIndexable",
  "multipleTitleTag&content&nonIndexable",
  "titleTagMissing&content&nonIndexable",
  "metaDescMissing&content&nonIndexable",

  "graphTagsIncomplete&socialTag",
  "graphUrlNotMatchingCanonical&socialTag",
  "twitterCardIncomplete&socialTag",

  "missingAltText&imagesFlag",
  "httpsPageLinksToHTTPImage&imagesFlag",
  "imageRedirects&imagesFlag",
  "PageHasRedirectedImage&imagesFlag",

  "httpsPageLinksToHttpJs&jsFlags",
  "jsRedirects&jsFlags",
  "PageHasRedirectedJs&jsFlags",

  "cssBroken&cssFlags",
  "pageHasBrokenCss&cssFlags",
  "httpsPageLinksToHttpCss&cssFlags",
  "cssRedirects&cssFlags",
  "PageHasRedirectedCss&cssFlags",
];

export const getPriorityFilteredFlags = (selectedFlags, selectedPriority) => {
  if (!selectedPriority) return selectedFlags;

  const priorityMap = {
    High: errorArray,
    Medium: warningArray,
    Low: infoArray,
  };

  const validFlags = priorityMap[selectedPriority] || [];
  return selectedFlags.filter(flag => validFlags.includes(flag));
};

export const initialColumns = {
  col_ab51Pm: { items: [], offset: 0, hasMore: true, loading: false },
  col_cd60Zk: { items: [], offset: 0, hasMore: true, loading: false },
  col_ef81Kd: { items: [], offset: 0, hasMore: true, loading: false },
  col_ij93Jl: { items: [], offset: 0, hasMore: true, loading: false },
};

export const statusAndId = {
  open: "col_ab51Pm",
  closed: "col_ef81Kd",
  reopen: "col_ij93Jl",
  progress: "col_cd60Zk",
};
